import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpMethodService } from './http-method.service';
import { Router } from '@angular/router';
import { ControlsService } from './controls.service';
import { UntypedFormGroup } from '@angular/forms';
import { Respuesta } from '../interfaces';
import { environment } from '../../../environments/environment';
import { FormGroup } from '@angular/forms';

@Injectable()
export class AuthenticationService {
  // clientId = 'sK1iLEbikNhF1yyw6zQR5ggF61XSHyRIfTzM782j';
  // clientSecret = 'oYnmcy3EszQSzj8JkcjzVBD0UqGDNMVGo42fxMhlDT9inNK6WePyCARUJ' +
  //               'h0SphncmcT48K7LPFi90CqufEDzAiVan2Fzba2CtSaKPSsgG3cPfvDDJTe9kkSj2o98Dtmu';

  clientId = environment.clientId;
  clientSecret = environment.clientSecret;

  // private clientId = 'B6ryk2bumB7OejNHuFbce2xNFjtrzXvEOy1Eg9hJ';
  // private clientSecret = 'so6rZUOFVlKJw63rqp9rN11dJp6EioYe0wNPGu5Znc5ofvya4wRIBdJ1oF1nBOeE0EKEINzjIBPciKyq29sxSEJJ5c6Ls66umDd4fm2G5RVIGtdcbRhJOO3ET71c8Oha';

  constructor(private http: HttpClient,
              private httpService: HttpMethodService,
              private controlService: ControlsService,
              private router: Router) {}

  // async login<T>(userName: string, password: string, recaptcha: string) {
  async login<T>(form: FormGroup): Promise<any> {

    const online = navigator.onLine;

    if (!online) {
      this.controlService.msgError('Ha ocurrido un error al tratar de conectarse con el servidor.');
      return;
    }

    const _url = this.httpService.baseUrl + '/o/token/';
   
    let body = new HttpParams();

    body = body.append('grant_type', 'password');
    // body = body.append('username', userName);
    // body = body.append('password', password);
    // body = body.append('recaptcha', recaptcha);
    body = body.append('username', form.controls.email.value);
    body = body.append('password', form.controls.password.value);
    body = body.append('client_id', this.clientId);
    body = body.append('client_secret', this.clientSecret);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<any>(_url, body, { headers }).toPromise();

  }

  refresh_token() {

    const _url = this.httpService.baseUrl + '/o/token/';
    const token = JSON.parse(localStorage.getItem('tokenCF'));

    if (!token) return null;
    let body = new HttpParams();

    body = body.append('grant_type', 'refresh_token');
    body = body.append('client_id', this.clientId);
    body = body.append('client_secret', this.clientSecret);
    body = body.append('refresh_token', token.refresh_token);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<any>(_url, body, { headers });

  }

  async logout() {
    localStorage.removeItem('currentUserCF');
    localStorage.removeItem('isLoggedinCF');
    localStorage.removeItem('tokenCF');
    localStorage.removeItem('menuCF');
    localStorage.removeItem('dateCF');
    localStorage.removeItem('lastPermissionRefreshCF');
    // Abrir una pestaña para el login y luego cerrar la actual
    window.open('/login', '_self');
  }

}
